export default __webpack_public_path__ + "static/media/landBox.e27ae1b4.png";